<template>
    <v-dialog v-model="dialog" persistent max-width="855px">
        <!-- Кнопка вызова КАКОГО ИМЕННО диалогового окна -->
        <template>
            <div class="send-rate">
                <img class="send-rate__close-btn" src="/images/rates/close.svg" @click="close_modal()" />
                <div class="wrapper">
                    <template v-if="before_sended">
                        <template v-if="department">
                            <div class="send-rate__header">{{ department.name }}</div>
                            <div class="send-rate__rates">
                                <template v-for="rate in department.to_rates">
                                    <template v-if="rate.rate == '1'">
                                        <!-- rate.rate ?!?!? СЕРЬЕЗНО:? -->
                                        <img src="/images/rates/ants/bad.svg" :key="rate._id" />
                                    </template>
                                    <template v-if="rate.rate == '2'">
                                        <img src="/images/rates/ants/good.svg" :key="rate._id" />
                                    </template>
                                    <template v-if="rate.rate == '3'">
                                        <img src="/images/rates/ants/cool.svg" :key="rate._id" />
                                    </template>
                                </template>
                            </div>
                        </template>
                        <template v-else
                            ><div class="send-rate__header">Напишите свое мнение или пожелание</div>
                            <div id="choose_departament">
                                <v-select
                                    v-model="new_rate.to"
                                    :items="get_rates"
                                    item-text="name"
                                    item-value="_id"
                                    label="Выберите отдел"
                                    persistent-hint
                                    return-object
                                    single-line
                                ></v-select></div
                        ></template>
                        <DepartmentCommentRate
                            :new_rate="new_rate"
                            @close_modal="on_close_modal"
                            @before_send="on_before_send"
                            v-if="new_rate.to != new_rate.from"
                        ></DepartmentCommentRate>
                    </template>
                    <template v-else>
                        <SecondModal :new_rate="new_rate" @edit_comment="on_before_send" @clear_modal="on_close_modal"></SecondModal>
                    </template>
                </div>
            </div>
        </template>
        
    </v-dialog>
</template>

<script>
import CreateRate from './../CreateRate.vue'
import DepartmentCommentRate from './DepartmentCommentRate.vue'
import SecondModal from './SecondModal.vue'

import { mapGetters } from 'vuex'

export default {
    name: 'NewDepartmentRate',
    data: () => ({
        group: false,
        group_name: null,

        new_rate: {
            comment: '',
            progress_line: 0,
            from: localStorage.getItem('_id'),
            to: '',
            rate: 0,
            date: new Date().toISOString().substring(0, 10),
        },
    }),
    props: ['dialog', 'department', 'before_sended'],
    watch: {
        department: function (val) {
            this.new_rate.to = val._id
        },
    },
    components: {
        CreateRate,
        DepartmentCommentRate,
        SecondModal,
    },

    computed: {
        ...mapGetters(['get_rates']),
    },
    methods: {
        on_close_modal(value) {
            console.log(value, 'valuevvv');
            this.$emit('close_modal', value)
        },

        on_before_send(value) {
            this.$emit('edit_before_send', value)
        },

        on_edit_comment(value){
            this.before_send = value
        },

        close_modal() {

            this.new_rate.comment = ''
            this.new_rate.progress_line = 0
            this.new_rate.to = ''
            this.new_rate.rate = 0

            this.$emit('close_modal', false)
        },
        get_percent(rates, type) {
            let x = []

            switch (type) {
                case 'low':
                    x = rates.filter((rate) => rate.rate == '1')
                    break
                case 'middle':
                    x = rates.filter((rate) => rate.rate == '2')
                    break
                case 'high':
                    x = rates.filter((rate) => rate.rate == '3')
                    break

                default:
                    break
            }

            if (x.length == 0) return `0 %`
            return ` ${((x.length / rates.length) * 100).toFixed()} %`
        },
    },
}
</script>

<style scoped>
.rates__grid {
    width: 1218px;
    margin: 20px auto;
}

.lvl-1,
.lvl-2,
.lvl-3,
.lvl-4 {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 10px;
    width: 1218px;
}

.lvl-1 .department {
    width: 296px;
    height: 210px;
}

.lvl-2 .department {
    width: 235px;
    height: 200px;
}

.lvl-3 .department {
    width: 223px;
    height: 180px;
}

.lvl-3 .department .department__name {
    font-size: 18px;
}

.lvl-3 .department:nth-child(3) {
    width: 282px;
    height: 180px;
}

.lvl-4 .department {
    width: 194px;
    height: 182px;
}

.department {
    display: flex;
    background: #ffffff;
    border-radius: 30px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.department__statuses {
    display: flex;
    width: 150px;
    justify-content: space-between;
    margin-bottom: 10px;
}

.department__statuses div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    font-weight: bold;
}

.department__statuses div img {
    height: 36px;
    margin-bottom: 8px;
}

.department__name {
    font-size: 22px;
}

.color-blue {
    color: #284b99;
}

.color-yellow {
    color: #faaf50;
}

.color-green {
    color: #65b337;
}
</style>